app.service('basketDependentProduct', function (modal, broker, scroll, html, cartManager, basketAnalytics) {
	let isOneInit = false;

	function addProduct(productId) {
		cartManager.simpleAddProduct({
			productId: productId
		}, function () {
			scroll.to({ $element: $('#cart-summarize') });
			broker.trigger('REFRESH_BASKET_VIEW', { type: 'add-dependent-product', productId: productId });
		});
	}
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$('body').on('click', '.js-add-modal-dependent-product', function (event) {
				event.preventDefault();
				modal.close(false);
				basketAnalytics.addDependentProduct($(this).data('plu'), $(this).data('parent'), 'service_details');
				addProduct($(this).data('product'));
			}).on('click', '.js-add-dependent-product', function (event) {
				event.stopPropagation();
				event.preventDefault();
				basketAnalytics.addDependentProduct($(this).data('plu'), $(this).data('parent'), 'product_details');
				addProduct($(this).data('product'));
			}).on('click', '.js-dependent-product-modal', function () {
				const modalVersion = html.has('new-services') ? 'new' : 'old';
				event.preventDefault();
				modal.generate({
					id: 'dependent-product-modal',
					content: $('#basket-' + modalVersion + '-dependent-product-' + $(this).data('product')).html(),
					modifier: modalVersion === 'new' ? 'remodal-right' : 'remodal-full-width'
				});
			});
		}
	}
	return {
		init
	};
});
